import { AccordionMarriage } from 'mutation/view-models/registration-marriage';
import { Marriage } from 'shell/models/person/marriage';
import { ActType } from 'shell/constants/act-type';
import { transformDocumentDigital } from 'shell/utils/consult-person/request-transformer/shared/transform-document-digital';
import { transformMarriageAnpr05 } from 'shell/utils/consult-person/request-transformer/marital-status/marriage-anpr-05';

export const transformerRequestMarriageAnpr05Mutation = (
  values: AccordionMarriage | undefined
): Marriage | undefined => {
  const matrimonio = transformMarriageAnpr05({
    ...values,
    digital: values?.digital || undefined,
  });

  const withActPaper =
    values?.paper?.actYear ||
    values?.paper?.actPart ||
    values?.paper?.actSeries ||
    values?.paper?.actNumber ||
    values?.paper?.actVolume ||
    values?.paper?.actDate ||
    values?.paper?.actMunicipality?.description ||
    values?.paper?.actMunicipality?.id ||
    values?.paper?.actMunicipality?.province;

  return matrimonio
    ? {
        ...(matrimonio || {}),
        datiMatrimonio: matrimonio.datiMatrimonio
          ? {
              ...(matrimonio.datiMatrimonio || {}),
              attoEventoANPR:
                values?.actType === ActType.SenzaAtto
                  ? undefined
                  : {
                      atto:
                        withActPaper && values?.actType === ActType.AttoCartaceo
                          ? {
                              anno: values?.paper?.actYear || undefined,
                              parte: values?.paper?.actPart || undefined,
                              serie: values?.paper?.actSeries || undefined,
                              numeroAtto: values?.paper?.actNumber || undefined,
                              volume: values?.paper?.actVolume || undefined,
                              dataFormazioneAtto:
                                values?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
                              trascritto: values?.paper?.transcribed ? '1' : undefined,
                              comuneRegistrazione: values?.paper?.actMunicipality
                                ? {
                                    nomeComune:
                                      values?.paper?.actMunicipality?.description || undefined,
                                    codiceIstat: values?.paper?.actMunicipality?.id || undefined,
                                    siglaProvinciaIstat:
                                      values?.paper?.actMunicipality?.province || undefined,
                                  }
                                : undefined,
                            }
                          : undefined,
                      attoANSC:
                        values?.actType === ActType.AttoDigitale
                          ? transformDocumentDigital(values?.digital || undefined)
                          : undefined,
                    },
            }
          : undefined,
      }
    : undefined;
};
